import React from 'react';
import {createRoot} from 'react-dom/client';
import {LoginWrapper} from '~library/organisms/LoginModal/LoginWrapper';
import {getURLParameter} from '~/common/utils';
import {toast, ToastContainer} from 'react-toastify';
import {toastAlert} from '~library/atoms/Toast';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {Typography} from '~library/atoms/Typography';
import 'react-toastify/dist/ReactToastify.min.css';

const onSignupSuccess = () => {
  const next = getURLParameter('next');
  if (next) {
    window.location.href = next;
  } else {
    window.location.href = '/';
  }
};
const onLoginSuccess = () => {
  onSignupSuccess();
};
const onCloser = () => {};

export const StandaloneLogin = () => (
  <div className="meganav-login-modal__wrapper">
    <LoginWrapper
      onLoginSuccess={onLoginSuccess}
      onCloser={onCloser}
      onSignupSuccess={onSignupSuccess}
      isModal={false}
    />
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      icon={false}
    />
  </div>
);

const container = document.getElementById('loginRoot');

if (container) {
  const root = createRoot(container);
  root.render(<StandaloneLogin />);
  if (window.errorMessages) {
    for (const errorMessage of window.errorMessages) {
      toastAlert(
        <Typography variant="paragraph2" classNames="toast__message__title" as="span">
          {errorMessage}
        </Typography>,
        {
          type: 'error',
          icon: <AlertLineIcon ratio={0.65} />,
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
          id: 'login-error',
        }
      );
    }
  }
}
